module.exports = __webpack_public_path__ + "fonts/Graphik-Super-Web.450c25f.woff";